module.exports = __webpack_public_path__ + "static/img/funkobae_ka.e4d05f9.jpg";